import { render } from "./Urology.vue?vue&type=template&id=15a6da0f&scoped=true"
import script from "./Urology.vue?vue&type=script&lang=ts"
export * from "./Urology.vue?vue&type=script&lang=ts"

import "./Urology.vue?vue&type=style&index=0&id=15a6da0f&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-15a6da0f"

export default script